WiseMetering.Model.SiteDocument = WiseMetering.Model.extend({
    urlRoot: '/site_documents',
});
